import store from "@/store";

const IDLE_TIMEOUT = 2000;

class InactivityMonitor {
  constructor() {
    this.timer = null;
  }

  initialize() {
    this.resetIdleTimeout();

    window.addEventListener("load", () => this.resetIdleTimeout());
    window.addEventListener("mousemove", () => this.resetIdleTimeout());
    window.addEventListener("mousedown", () => this.resetIdleTimeout());
    window.addEventListener("touchstart", () => this.resetIdleTimeout());
    window.addEventListener("touchmove", () => this.resetIdleTimeout());
    window.addEventListener("keydown", () => this.resetIdleTimeout());
    window.addEventListener("click", () => this.resetIdleTimeout());
    window.addEventListener("scroll", () => this.resetIdleTimeout(), true);
  }

  async resetIdleTimeout() {
    clearTimeout(this.timer);

    // If was considered idle, toggle it so that they're not idle anymore
    if (this.isIdle) {
      this.idleStop();
    }

    // If the user doesn't move for IDLE_TIMEOUT milliseconds, then they're considered idle
    this.timer = setTimeout(() => this.idleStart(), IDLE_TIMEOUT);
  }

  idleStart() {
    store.dispatch("inactivity/idleStart");
  }

  idleStop() {
    store.dispatch("inactivity/idleStop");
  }

  get isIdle() {
    return store.state.inactivity.idle;
  }
}

export { InactivityMonitor };
